import { useState } from "react";

import { PageHeader } from "~/components/layout/PageHeader";
import { Card, CardContent } from "~/components/ui/card";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "~/components/ui/sheet";
import PaymentAssignmentForm from "~/pages/payments/components/PaymentAssignmentForm";
import UnidentifiedPaymentsSummary from "~/pages/payments/components/UnidentifiedPaymentsSummary";
import UnidentifiedPaymentsTable from "~/pages/payments/components/UnidentifiedPaymentsTable";
import { useClientSuggestions } from "~/pages/payments/hooks/useClientSuggestions";
import { useUnidentifiedPayments } from "~/pages/payments/hooks/useUnidentifiedPayments";

export default function UnidentifiedPaymentsPage() {
  const { payments, loading, totalAmount, assignPayment } =
    useUnidentifiedPayments();
  const [selectedPaymentId, setSelectedPaymentId] = useState<number | null>(
    null
  );
  const [isAssignDrawerOpen, setIsAssignDrawerOpen] = useState(false);

  const selectedPayment = payments.find((p) => p.id === selectedPaymentId);

  // Only fetch client suggestions when a payment is selected
  const { clientSuggestions, requestSuggestions, loadingSuggestions } =
    useClientSuggestions(selectedPayment?.amount || 0);

  const handleAssignClick = (paymentId: number) => {
    setSelectedPaymentId(paymentId);
    setIsAssignDrawerOpen(true);
  };

  const handleAssignSubmit = async (
    clientId: string,
    salesRequestId?: string
  ) => {
    if (selectedPaymentId) {
      // If "none-selected" is passed, convert it to undefined
      const finalRequestId =
        salesRequestId === "none-selected" ? undefined : salesRequestId;
      await assignPayment(selectedPaymentId, clientId, finalRequestId);
      setIsAssignDrawerOpen(false);
    }
  };

  // When drawer closes, reset selections
  const handleSheetOpenChange = (open: boolean) => {
    setIsAssignDrawerOpen(open);
    if (!open) {
      setSelectedPaymentId(null);
    }
  };

  return (
    <div className="mx-auto">
      <PageHeader title="Pagos No Identificados" className="ml-8" />

      <div className="container mx-auto py-6">
        <UnidentifiedPaymentsSummary
          count={payments.length}
          totalAmount={totalAmount}
        />

        <Card className="mt-6">
          <CardContent className="p-6">
            <UnidentifiedPaymentsTable
              payments={payments}
              loading={loading}
              onAssignClick={handleAssignClick}
            />
          </CardContent>
        </Card>
      </div>

      <Sheet open={isAssignDrawerOpen} onOpenChange={handleSheetOpenChange}>
        <SheetContent className="sm:max-w-md">
          <SheetHeader>
            <SheetTitle>Asignar Pago</SheetTitle>
          </SheetHeader>

          <div className="mt-6">
            {selectedPayment && (
              <PaymentAssignmentForm
                payment={selectedPayment}
                clientSuggestions={clientSuggestions}
                requestSuggestions={requestSuggestions}
                loading={loadingSuggestions}
                onSubmit={handleAssignSubmit}
                onCancel={() => setIsAssignDrawerOpen(false)}
              />
            )}
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
